import type { AxiosInstance } from "axios";
import type { MagicLinkRedirect } from "@shared/schemas/magic-link.schemas";
import type { MagicLink } from "@shared/schemas/open-invitation-with-magic-links.schemas";

const MAGIC_LINKS_API_PATH = "/api/v1/magic-links";

export function createMagicLinksApi(apiClient: AxiosInstance) {
  async function getByEntity(
    type: string,
    entityIdPublic: string,
  ): Promise<readonly MagicLink[]> {
    const params = new URLSearchParams({
      type,
      entityIdPublic,
    });
    const response = await apiClient.get<MagicLink[]>(
      `${MAGIC_LINKS_API_PATH}?${params.toString()}`,
    );
    return response.data;
  }

  async function process(idPublic: string): Promise<MagicLinkRedirect> {
    const response = await apiClient.get<MagicLinkRedirect>(
      `${MAGIC_LINKS_API_PATH}/${encodeURIComponent(idPublic)}`,
    );
    return response.data;
  }

  return {
    getByEntity,
    process,
  } as const;
}
